import { render, staticRenderFns } from "./TablePrice.vue?vue&type=template&id=dd999648&scoped=true&"
import script from "./TablePrice.vue?vue&type=script&lang=js&"
export * from "./TablePrice.vue?vue&type=script&lang=js&"
import style0 from "./TablePrice.vue?vue&type=style&index=0&id=dd999648&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dd999648",
  null
  
)

export default component.exports